var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlert24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlert24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C23.9924423,18.624284 18.624284,23.9924423 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.71428571 C6.31935686,1.71428571 1.71428571,6.31935686 1.71428571,12 C1.71428571,17.6806431 6.31935686,22.2857143 12,22.2857143 C17.6806431,22.2857143 22.2857143,17.6806431 22.2857143,12 C22.279573,6.32190261 17.6780974,1.72042701 12,1.71428571 Z M11.9888571,15.75 C12.935631,15.75 13.7031429,16.5175119 13.7031429,17.4642857 C13.7031429,18.4110596 12.935631,19.1785714 11.9888571,19.1785714 C11.0420833,19.1785714 10.2745714,18.4110596 10.2745714,17.4642857 C10.2745714,16.5175119 11.0420833,15.75 11.9888571,15.75 Z M11.9892857,4.79614286 C12.7961737,4.79614286 13.4502857,5.45025484 13.4502857,6.25714286 L13.1622857,13.6834286 C13.1887623,14.1231705 12.9691984,14.5413258 12.5921728,14.7691978 C12.2151473,14.9970699 11.7428527,14.9970699 11.3658272,14.7691978 C10.9888016,14.5413258 10.7692377,14.1231705 10.7957143,13.6834286 L10.5282857,6.25714286 C10.5282857,5.45025484 11.1823977,4.79614286 11.9892857,4.79614286 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#C73500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlert24);
export default __webpack_public_path__ + "static/media/messageAlert24.4942e527337e3a3c09e0f1aabfe29ed8.svg";
export { ForwardRef as ReactComponent };